/* unplugin-vue-components disabled */import script from "./Gpyq.vue?vue&type=script&lang=ts&setup=true"
export * from "./Gpyq.vue?vue&type=script&lang=ts&setup=true"

import "./Gpyq.vue?vue&type=style&index=0&id=b6f2ca20&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6f2ca20"]])

export default __exports__